module.exports = __webpack_public_path__ + "static/media/icon-web.0a8dfa71.png";